import gql from 'graphql-tag';

const DELETE_INPUT_FIELD_MUTATION = gql`
  mutation deleteCategoryInput($_id: ID!) {
    deleteCategoryInput(_id: $_id)
  }
`;

export default DELETE_INPUT_FIELD_MUTATION;
